export default __webpack_public_path__ + "static/media/planned-station-icon.d1226488.png";